import { render, staticRenderFns } from "./MessageQueueTopologyTable.vue?vue&type=template&id=2c4d14d2"
import script from "./MessageQueueTopologyTable.vue?vue&type=script&lang=js"
export * from "./MessageQueueTopologyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports